(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('calendar', {
            parent: 'app',
            url: '/calendar?type',
            data: {
                authorities: [],
                pageTitle: 'platformAppTitle.calendar'
            },
            views: {
                'content': {
                    templateUrl: 'app/entities/calendar/calendar.html',
                    controller: 'CalendarController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                type: {
                    value: 'calendar',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('fontManagement');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('title');
                    return $translate.refresh();
                }]
            }
        })
        .state('calendar-xml', {
            url: '/calendar-xml/{id}',
            data: {
                authorities: [],
                pageTitle: 'platformAppTitle.calendar-xml'
            },
            views: {
                'navbar@': {
                    templateUrl: 'app/entities/calendar/calendar-xml.html',
                    controller: 'CalendarXmlController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('title');
                    return $translate.refresh();
                }]
            }
        })
            .state('calendarTitle', {
                parent: 'app',
                url: '/calendarTitle',
                data: {
                    authorities: [],
                    pageTitle: 'platformApp.productXml.home.title'
                },
                views: {
                    'content': {
                        templateUrl: 'app/entities/calendar/calendar-title.html',
                        controller: 'CalendarTitleController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,desc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('fontManagement');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('calendar-title-xml', {
                url: '/calendar-title-xml/{id}',
                data: {
                    authorities: [],
                    pageTitle: 'platformAppTitle.calendar-title-xml'
                },
                views: {
                    'navbar@': {
                        templateUrl: 'app/entities/calendar/calendar-title-xml.html',
                        controller: 'CalendarTitleXmlController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('title');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();
